import React, {forwardRef, memo, useCallback, useImperativeHandle, useState,} from "react";

import {GetShippingAPIParams2, ShippingItemListType,} from "../../../api/apiTypes";
import {Controller, CustomOverlay, OpenLayers, useCluster,} from "@delivus/react-open-layers";
import ShippingsTooltip from "../shippingMap/ShippingsTooltip";
import {HoveredShippingTooltipType} from "../../screens/shipping/ShippingMapScreen";
import {useShippings} from "../../../api/useShippings";
import {Button} from "antd";
import {useSearchParams} from "react-router-dom";
import {PlanRefresh} from "../../../assets/svgs/planRefresh";
import {useMapFunctions} from "../../molecules/map/useMapFunctions";
import {Map} from "ol";
import TileLayer from "ol/layer/Tile";
import {XYZ} from "ol/source";
import debounce from "lodash.debounce";
import {MAX_ZOOM, MIN_ZOOM} from "../plan/PlanMap";

interface Props {
  params: GetShippingAPIParams2;
  onSelectShippings: (shippings: ShippingItemListType[]) => void;
}

const ShippingMap = forwardRef(({onSelectShippings, params}: Props, ref) => {
  const [map, setMap] = useState<Map>();
  const [zoom, setZoom] = useState(12);
  const {
          clusterStyle, clusterOverStyle, handleMouseOverCluster, handleClickCluster, handleReset
        } = useMapFunctions<ShippingItemListType>(onSelectShippings);
  const [hoveredShippingTooltip, setHoveredShippingTooltip] = useState<HoveredShippingTooltipType<ShippingItemListType>>();
  const {features, mutate} = useShippings(params);
  const [_, setSearchParams] = useSearchParams();
  
  useCluster({
    features,
    map,
    zoom,
    onClick: handleClickCluster,
    onOver: (selected, deselected, event) => handleMouseOverCluster(selected, deselected, event, setHoveredShippingTooltip, setHoveredShippingTooltip),
    clusterStyle: clusterStyle,
    overStyle: clusterOverStyle,
    layerOptions: {zIndex: 15}
  });
  
  const handleRefresh = useCallback(() => {
    setSearchParams({})
  }, [setSearchParams]);
  
  useImperativeHandle(ref, () => ({
    reset: handleReset, refresh: () => {
      console.log("useShippings mutate");
      mutate();
    },
  }), [handleReset, mutate]);
  
  const handleMapBoundChanged = useCallback(debounce((event: any) => {
    const map = event.map;
    if (map) {
      const view = map.getView();
      const newZoom = view.getZoom();
      console.log("handleMapBoundChanged actually moved zoom", newZoom);
      setZoom(newZoom);
      const projection = map.getView()
                            .getProjection();
      console.log("Projection:", projection.getCode());
      const extent = view.calculateExtent(map.getSize());
      console.log("extent", extent)
    }
  }, 300), []);
  
  const vworldBaseLayer = new TileLayer({
    source: new XYZ({
      url: `http://api.vworld.kr/req/wmts/1.0.0/${process.env.REACT_APP_MAP_KEY}/white/{z}/{y}/{x}.png`,
    }), properties: {name: "base-vworld-base"}, minZoom: MIN_ZOOM, maxZoom: MAX_ZOOM, // zIndex: 2,
    preload: Infinity,
  });
  
  return (<div className={"map-container"}>
    <OpenLayers
      // layers={[vworldBaseLayer]}
      interactionOptions={{pinchZoom: true}}
      viewOptions={{
        zoom: 13, projection: 'EPSG:4326', //Use [lon, lat] directly
      }}
      initialCenter={[126.83, 37.57]}
      showZoom
      onInit={setMap}
      onMoveEnd={handleMapBoundChanged}
    >
      <Controller
        id={"right-control"}
        className={"float right"}
      >
        <Button
          type={"primary"}
          className={"button false"}
          onClick={handleRefresh}>
          
          <PlanRefresh color={"var(--primary)"} />
        </Button>
      </Controller>
      <CustomOverlay
        id={"shipping-tooltip"}
        className={"tooltip"}
        position={hoveredShippingTooltip?.position}
      >
        <ShippingsTooltip shippings={hoveredShippingTooltip?.shippings} />
      </CustomOverlay>
    </OpenLayers>
  </div>);
});

export default memo(ShippingMap);
